import React, {FC} from 'react';
import {MAX_BIT_COMPONENT} from './constants';

import {SecondaryButton} from 'components';

import i18n from 'i18next';

type SelectComponentTypeProps = {
  onClick: () => void;
  disabled?: boolean;
};

const I18N_MAX_COMPONENTS_KEY =
  'wisbitPage.selectComponentType.maximumComponents';
const I18N_ADD_COMPONENT_KEY = 'wisbitPage.selectComponentType.addComponent';

const NewComponentButton: FC<SelectComponentTypeProps> = ({
  onClick,
  disabled,
}) => {
  const secondaryButtonText = disabled
    ? i18n.t(I18N_MAX_COMPONENTS_KEY, {count: MAX_BIT_COMPONENT})
    : i18n.t(I18N_ADD_COMPONENT_KEY);

  return (
    <div className="w-1/2 text-right new-component-button">
      <SecondaryButton onClick={onClick} disabled={disabled}>
        {secondaryButtonText}
      </SecondaryButton>
    </div>
  );
};

export default NewComponentButton;
